import { MonitoringIssueData } from '@Modules/site/conditionMonitoring/condition-monitoring.service';
import { newDate } from './datetime.utils';

export const OPEN_VISUAL_INSPECTION_STATUS = [
  'VisualInspectionAction.Continue to Monitor',
  'VisualInspectionAction.Schedule for Removal in Next Service',
];

export function getExpectedInspectionDate(issue: MonitoringIssueData): Date {
  const { inspectionDate, inspectionFrequencyDays, daysToResolve } = issue;
  return newDate(inspectionDate, inspectionFrequencyDays || daysToResolve || 0);
}

export function getInspectionDueDate(visualInspectionRecord): Date | undefined {
  const { date, actionDaysToResolve } = visualInspectionRecord;
  return newDate(date, actionDaysToResolve);
}
